import React from 'react';
import PreloadedImage from './PreloadedImage';
import VisibilitySensor from 'react-visibility-sensor';

const VSImage = (props) => (
    <VisibilitySensor partialVisibility scrollCheck resizeCheck>{({isVisible}) => (
        <PreloadedImage {...props} hidden={!isVisible}/>
    )}</VisibilitySensor>
);

export default VSImage;



// WEBPACK FOOTER //
// ./src/components/VSImage.js